import { Component, OnInit, Input, ElementRef, OnDestroy } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ClienteContatoService } from "src/app/services/cliente-contato.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import Editor from "src/assets/ckeditor5-41.3.0/build/ckeditor";

@Component({
  selector: "app-chat-contato",
  templateUrl: "./chat-contato.component.html",
  styleUrls: ["./chat-contato.component.scss"],
})
export class ChatContatoComponent implements OnInit, OnDestroy {
  @Input() contato;
  contatoForm: UntypedFormGroup;
  selector: string;
  is_ddg: boolean = false;
  newSubs: Subscription;
  public Editor = Editor;
  public editorConfig: any;

  constructor(
    public activeModal: NgbActiveModal,
    private _fb: UntypedFormBuilder,
    private contatoService: ClienteContatoService,
    private toastr: ToastrService,
    private elemRef: ElementRef,
    private translate: TranslateService,
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
  }

  checkDdg($event) {
    this.is_ddg = $event.target.checked
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85'
    this.bulidForm();
    this.setEditorConfig();
    if (this.contato !== undefined) {
      //console.log("detalhes");
      //console.log(this.contato)
      //this.patchValue(this.contato);
    } else {
      //console.log("criando");
    }
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  close(result?) {
    //console.log(this.contatoForm.value);
    this.activeModal.close(result);
  }

  setEditorConfig(): void {
    this.editorConfig = {
      image: {
        upload: {
          types: []
        }
      },
      toolbar: {
        items: [
          'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', '|',
          'bulletedList', 'numberedList', 'outdent', 'indent', '|',
          'link', 'blockQuote', 'code', 'insertTable', '|',
          'undo', 'redo'
        ]
      },
      placeholder: this.translate.instant('INSIRA_TEXTO_IMAGEM')
    };
  }

  bulidForm() {
    this.contatoForm = this._fb.group({
      cliente: ["", Validators.required],
      descricao: ["", Validators.required],
      email: ["", [Validators.email]],
      telefone: [""],
      celular: [""],
      whatsapp: ["", Validators.required],
      padrao: ["", Validators.required],
      observacao: [""],
    });
  }

  onSubmit() {
    let basicPayload = {
      clienteContato: {
        celular: this.contatoForm.get("celular").value,
        cliente_id: this.contatoForm.get("cliente").value.id,
        descricao: this.contatoForm.get("descricao").value,
        email: this.contatoForm.get("email").value,
        is_padrao: this.contatoForm.get("padrao").value,
        observacao:	this.contatoForm.get('observacao').value,
        //operadora_id: "null",
        possui_whatsapp: this.contatoForm.get("whatsapp").value,
        telefone: this.contatoForm.get("telefone").value,
      },
    };

    this.newSubs = this.contatoService.createClienteContato(basicPayload).subscribe(
      (result) => {
        this.close();
      }, (error) => console.error('submit', error)
    );
    //console.log(basicPayload);
  }

  onSubmitSet() {
    let basicPayload = {
      clienteContato: {
        celular: this.contatoForm.get("celular").value,
        cliente_id: this.contatoForm.get("cliente").value.id,
        descricao: this.contatoForm.get("descricao").value,
        email: this.contatoForm.get("email").value,
        is_padrao: this.contatoForm.get("padrao").value,
        observacao:	this.contatoForm.get('observacao').value,
        //operadora_id: "null",
        possui_whatsapp: this.contatoForm.get("whatsapp").value,
        telefone: this.contatoForm.get("telefone").value,
      },
    };

    this.newSubs = this.contatoService.createClienteContato(basicPayload).subscribe(
      (result) => {
        //console.log(result);
        this.close(result.clienteContato);
      }, (error) => console.error('submitSet', error)
    );
    //console.log(basicPayload);
  }

  verificaRequerido(campo): boolean {
    if (this.contatoForm.get(campo).value !== '') {
      return false;
    } else {
      return true;
    }
  }

}
